<template>
  <b-card
    header-text-variant="left"
    header-bg-variant="white"
    body-class="card-body-style"
    class="card-style"
  >
    <template v-slot:header>
      <h4 class="mb-0 header-style">{{formHeader}}</h4>
    </template>
    <!-- for loading page -->
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
    <!--confirm box-->
    <app-confirm :message="'Save?'" :show="showConfirmBox" @confirmed="confirmSave" @cancel="showConfirmBox=false" ></app-confirm>
    <form
      class="col-md-6 appinfopage"
      v-on:submit.prevent="submitVersionInfo"
    >
      <b-alert
        class="text-center"
        :show="successMessage != ''"
        variant="success"
      > {{ successMessage }} </b-alert>
      <b-alert
        class="text-center"
        :show="errorMessage != ''"
        variant="danger"
      > {{ errorMessage }} </b-alert>
      <div class="appinfopage-inputs">
        <div class="form-group ">
          <label for="formGroupExampleInput">Version</label>
          <input
            type="text"
            class="form-control"
            id="version"
            placeholder="Enter New Version"
            v-model="appVersion.version"
            :disabled="editMode"
          >
        </div>
        <div
          class="form-group"
          style="padding-top:10px;"
        >
          <label for="formGroupExampleInput">Upload binary file</label>
          <div class="custom-file">
            <b-form-file
              v-model="appVersion.file"
              :state="Boolean(appVersion.file)"
              placeholder="Choose file..."
              :accept="acceptFileType"
              id="binaryInputFile"
              class="custom-file-input"
            ></b-form-file>
            <label class="custom-file-label">{{ appVersion.file ? appVersion.file.name : 'Choose file' }}</label>
          </div>
        </div>

        <div class="form-group ">
          <label for="formGroupExampleInput">Compatibility</label>
          <input
            type="text"
            class="form-control"
            id="compatibility"
            placeholder="Compatibility"
            v-model="appVersion.compatibility"
          >
        </div>
        <div class="form-group">
          <label for="formGroupExampleInput2">Release notes</label>
          <textarea
            class="form-control"
            id="details"
            rows="3"
            v-model="appVersion.noteNew"
          ></textarea>
        </div>
      </div>
      <div class="appinfopage-catimage">
        <h6>Optional</h6>
        <div class="form-group ">
          <label for="formGroupExampleInput">Category</label>
          <b-form-select
            name="category"
            id="category"
            placeholder="Category"
            class="form-control"
            v-model="appVersion.category"
            :options="categories"
          ></b-form-select>
        </div>
        <div class="form-group">
          <label for="formGroupExampleInput">App Icon</label>
          <div
            class="old-icon-checkbox"
            v-if="!noVersion"
          >
            <label
              for="check-button"
              class="old-version-label"
            >Use Old Version</label>
            <b-form-checkbox
              name="chkOldIcon"
              id="chkOldIcon"
              switch
              @change="useOldIcon"
              class="right-checkbox"
            >
            </b-form-checkbox>
          </div>
          <div
            class="custom-file"
            v-if="!oldIcon"
          >
            <input
              type="file"
              class="custom-file-input"
              id="imageFile"
              @change="previewIcon"
              accept=".jpg, .png, .gif, .ico"
            >
            <label
              class="custom-file-label"
              for="customFile"
            >Choose file</label>
          </div>
        </div>
        <div
          class="form-group"
          v-show="iconPreviewOn"
        >
          <img
            class="thumbnail-size img-fluid img-thumbnail"
            id="iconPreview"
          />
          <b-button
            v-if="removeIconBtn"
            @click="removeIcon"
            class="ml-2 remove-icon"
            size="sm"
            variant="outline-danger"
          > <i
              class="fa fa-times"
              aria-hidden="true"
            ></i>
            Remove
          </b-button>
        </div>
        <div
          class="form-group"
          style="padding-top:10px;"
        >
          <label for="formGroupExampleInput">Upload screenshots</label>
          <div
            class="form-group"
            id="screenshotPreview"
          >
            <app-gallery
              :show="showGallery"
              :gallery="gallery"
              :removeGallery="removeGallery"
              :versionDefault="false"
            >
            </app-gallery>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <button
          type="submit"
          class="btn b-btn create-btn save-btn col-md-4"
          :disabled="!readyToSave"
        >Save</button>
        <button
          type="button"
          class="btn b-btn cancel-btn col-md-4"
          @click="goBack"
        >Cancel</button>
      </div>
      <div class="form-group row">
        <div class="col-lg-12">
          <div
            class="alert alert-success"
            role="alert"
            v-if="saveDone"
          >
            Successfully saved. <button
              type="button"
              class="btn btn-link"
              v-on:click="backToList"
            >Click here to close this form.</button>
          </div>
        </div>
      </div>
    </form>
  </b-card>
</template>
<script>
import AppVersionInfo from '@/models/appversion.js';
import Gallery from '@/components/Gallery';
import Loading from '@/components/Loading';
import ConfirmBox from '@/components/ConfirmBox';
import axios from 'axios';
import _ from 'lodash';
import PkgReader from 'reiko-parser';

export default {
  name: 'VersionForm',
  data () {
    return {
      appVersion: {},
      appVersionOld: {},
      showConfirmBox: false,
      saveDone: false,
      loading: false,
      removeIconBtn: false,
      iconPreviewOn: false,
      oldIcon: false,
      editMode: false,
      noVersion: false,
      isLoading: false,
      readyToSave: false,
      isWatched: false,
      appId: '',
      versionId: '',
      previewImages: [],
      showGallery: true,
      removeGallery: [],
      gallery: [],
      images: [],
      formHeader: 'Add Version',
      screenshotsCountOld: 0,
      acceptFileType: '',
      successMessage: '',
      errorMessage: '',
      categories: [{ value: 'Life Style', text: 'Life Style' }, { value: 'Others', text: 'Others' }]
    };
  },
  created: function () {
    document.title = 'Admin Console: Version Form';
    this.appId = this.$route.params.id;
    this.versionId = this.$route.params.versionid;
    this.getAppData();
  },
  watch: {
    'appVersion': {
      handler: function (v) {
        this.readyToSave = !_.isEqual(this.appVersionOld, v) || false;
        this.isWatched = true;
      },
      deep: true
    },
    gallery: {
      handler (val) {
        this.readyToSave = val.length !== this.screenshotsCountOld || false;
      },
      deep: true
    },
    'appVersion.file' () {
      const reader = new PkgReader(this.appVersion.file, 'apk', { withIcon: true });
      reader.parse((err, pkgInfo) => {
        if (err) {
          console.error(err);
        } else {
          console.log(pkgInfo); // pkgInfo.icon is encoded to base64
          // set version
          this.appVersion.version = pkgInfo.versionName;
          this.iconPreviewOn = true;
          this.removeIconBtn = true;
          document.getElementById('iconPreview').src = pkgInfo.icon;
          this.appVersion.thumbnail = this.dataURItoBlob(pkgInfo.icon);
          if (!this.readyToSave) {
            this.readyToSave = true;
          }
          // set compatibility
          this.appVersion.compatibility = 'support sdk version ' + pkgInfo.usesSdk.minSdkVersion;
          this.appVersion.category = 'Others';
        }
      });
    }
  },
  methods: {
    // Ref: https://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata/5100158
    dataURItoBlob (dataURI) {
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0) { byteString = atob(dataURI.split(',')[1]); } else { byteString = unescape(dataURI.split(',')[1]); }
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    submitVersionInfo () {
      this.showConfirmBox = true;
    },
    saveVersionInfo () {
      this.isLoading = true;
      this.readyToSave = false;
      this.appVersion.screenshots = [];
      this.appVersion.version = this.appVersion.version.replace(/\s/gi, '_');
      const appVersionInfo = new AppVersionInfo(this.appVersion);

      const fd = new FormData();
      for (let key in appVersionInfo) {
        if (key !== 'screenshots') {
          if ('thumbnail' === key) {
            if (appVersionInfo[key]) {
              fd.append(key, appVersionInfo[key]);
            }
          } else {
            fd.append(key, appVersionInfo[key]);
          }
        }
      }

      if (!this.editMode) {
        // Create
        if ('undefined' === fd.get('file')) {
          this.errorMessage = 'Please select binary file to upload.';
          return;
        }

        for (let image of this.gallery) {
          fd.append('screenshots', image.file || null);
        }
        axios({
          method: 'post',
          url: (process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app/' + this.appId + '/version'),
          data: fd,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
          const receivedResp = res.data;
          if ('Success' === receivedResp.message) {
            this.errorMessage = '';
            this.saveDone = true;
            this.isLoading = false;
            let sessionApp = JSON.parse(sessionStorage.getItem('app'));
            sessionApp.noVersion = false;
            sessionStorage.setItem('app', JSON.stringify(sessionApp));
            this.$router.push({ name: 'apps-details', params: { id: this.appId } });
          }
        })
          .catch(error => {
            this.isLoading = false;
            this.saveError = true;
            this.successMessage = '';
            if ('UAT-003' === error.response.data.code) {
              this.$router.push({ name: 'login' });
            }
            this.errorMessage = error.response.data.data.map(value => value.msg).join(', ') + '.';
          });
      } else {
        // Update
        for (let image of this.gallery) {
          if (image.file) {
            fd.append('screenshots', image.file || null);
          }
        }
        if (this.removeGallery.length > 0) {
          fd.append('removeScreenshot', this.removeGallery);
        }
        axios({
          method: 'patch',
          url: (process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app/' + this.appId + '/version/' + this.versionId),
          data: fd,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
          const receivedResp = res.data;
          if ('Success' === receivedResp.message) {
            this.isLoading = false;
            this.saveDone = true;
            this.$router.push({ name: 'apps-details', params: { id: this.appId } });
          }
        })
          .catch(error => {
            this.isLoading = false;
            this.saveError = true;
            console.log('Error :', error);
            this.successMessage = '';
            if ('UAT-003' === error.response.data.code) {
              this.$router.push({ name: 'login' });
            }
            this.errorMessage = error.response.data.data.map(value => value.msg).join(', ') + '.';
          });
      }
    },
    getAppData () {
      const AppInfo = JSON.parse(sessionStorage.getItem('app'));
      if (AppInfo) {
        if ('android' === AppInfo.platform) {
          this.acceptFileType = '.apk';
        } else if ('ios' === AppInfo.platform) {
          this.acceptFileType = '.ipa, .plist';
        }
        this.noVersion = AppInfo.noVersion;
      }
      document.title = 'Admin Console: Add new version';
      if (this.versionId) {
        this.isLoading = true;
        this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${this.appId}/version`, {
          headers: {
            Accept: 'application/json'
          }
        }).then(response => {
          let versions = response.data.data.versions;
          let currentVersionIndex = versions.findIndex(this.findVersion);
          this.appVersion = versions[currentVersionIndex];
          this.appVersionOld = JSON.parse(JSON.stringify(versions[currentVersionIndex])); // deep clone the object to be used in watch values
          this.screenshotsCountOld = this.appVersion.screenshots.length;
          for (let i = 0; i < this.appVersion.screenshots.length; i++) {
            let screenshot = this.appVersion.screenshots[i];
            let screenshotUrl = screenshot.url;
            let unid = screenshot.id;
            this.gallery.push({ id: unid, url: screenshotUrl });
          }
          if ('undefined' === this.appVersion.noteNew) {
            this.appVersion.noteNew = '';
          }
          document.getElementById('iconPreview').src = this.appVersion.thumbnail;
          this.editMode = true;
          this.formHeader = 'Edit Version';
          document.title = `Admin Console: ${this.formHeader}`;
          this.isLoading = false;
        }).catch(error => {
          this.saveError = true;
          console.log('Error :', error);
          this.successMessage = '';
          if ('UAT-003' === error.response.data.code) {
            this.$router.push({ name: 'login' });
          }
          this.errorMessage = error.response.data.message;
          this.isLoading = false;
        });
      }
    },
    findVersion (app) {
      return app.id === this.versionId;
    },
    previewIcon (e) {
      this.iconPreviewOn = true;
      if (e.target.files.length > 0) {
        this.removeIconBtn = true;
        document.getElementById('iconPreview').src = URL.createObjectURL(e.target.files[0]);
        this.appVersion.thumbnail = e.target.files[0];
        if (!this.readyToSave) {
          this.readyToSave = true;
        }
      }
    },
    removeIcon (e) {
      if (this.iconPreviewOn && !this.isWatched) {
        if (this.readyToSave) {
          this.readyToSave = false;
        }
      }
      document.getElementById('iconPreview').src = '';
      this.appVersion.thumbnail = '';
      this.removeIconBtn = false;
      this.iconPreviewOn = false;
    },
    backToList () {
      this.$router.push({ name: 'apps' });
    },
    useOldIcon (v) {
      this.oldIcon = v;
    },
    goBack () {
      this.$router.push({ name: 'apps-details', params: { id: this.appId } });
    },
    confirmSave () {
      this.showConfirmBox = false;
      this.saveVersionInfo();
    }
  },
  components: {
    'app-gallery': Gallery,
    'app-loading': Loading,
    'app-confirm': ConfirmBox
  }
};
</script>
<style scoped src="@/assets/css/appstore-form.css"></style>
